<template>
	<div id="threed">
		<div id="container"></div>
		<!-- <div class="loading">
			<div class="loading_d">
				<div class="loading_t">正在加载</div>
				<div class="loading_progress">
					<el-progress :text-inside="true" :stroke-width="22" :percentage="percentage"></el-progress>
				</div>
			</div>
		</div>-->
		<!-- <div style="position:absolute; bottom:10px; width:100vw; display:flex; justify-content:center">
			<el-button v-if="stateNow != 1" class="primary" @click="updateSceneState(1)">返回</el-button>
		</div>-->

		<transition name="el-zoom-in-bottom">
			<div class="hover_name" v-if="hover_show">{{ hover_name }}</div>
		</transition>
		<!-- <div style="position:absolute; bottom:10px; width:100vw; display:flex; justify-content:center">
			<el-button class="primary" @click="viewButtonClick(0)">首页</el-button>
			<el-button class="primary" @click="backgroundNight()">黑夜</el-button>
			<el-button class="primary" @click="backgroundDay()">白天</el-button>
			<el-button class="primary" @click="transparentAll()">全透明</el-button>
			<el-button class="primary" @click="opacityAll()">不透明</el-button>
		</div>-->
		<div style="position:absolute; bottom:10px; width:100vw; display:flex; justify-content:center">
			<el-button class="primary" @click="perspectiveOne">视角一</el-button>
			<el-button class="primary" @click="perspectiveTwo">视角二</el-button>
			<el-button class="primary" @click="perspectiveThree">视角三</el-button>
			<el-button class="primary" @click="perspectiveFour">视角四</el-button>
		</div>

		<transition name="el-zoom-in-top">
			<div class="infobox info" v-if="info_show">
				<infoboxSB ref="infobox" :id="choose_id" />
			</div>
		</transition>
	</div>
</template>

<script>
import * as THREE from "@/assets/three/build/three.module.js";
import { OrbitControls } from "@/assets/three/examples/jsm/controls/OrbitControls";
import { FBXLoader } from '@/assets/three/examples/jsm/loaders/FBXLoader.js';
import { Reflector } from '@/assets/three/examples/jsm/objects/Reflector.js';
import { Water } from '@/assets/three/examples/jsm/objects/Water.js';
import { FXAAShader } from '@/assets/three/examples/jsm/shaders/FXAAShader.js';
import { OutlinePass } from '@/assets/three/examples/jsm/postprocessing/OutlinePass.js';
import { EffectComposer } from '@/assets/three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from '@/assets/three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from '@/assets/three/examples/jsm/postprocessing/ShaderPass.js';
import { UnrealBloomPass } from '@/assets/three/examples/jsm/postprocessing/UnrealBloomPass.js';
import { GUI } from '@/assets/three/examples/jsm/libs/dat.gui.module.js';

import * as Tween from 'gsap';
import Commen from '@/assets/js/Commen.js';
import { EventHandler } from '@/assets/js/eventHandler.js';
import $ from "jquery";
import infoboxSB from './infobox/infoboxSB.vue';
// import { warn } from '@vue/runtime-core';



const SCENESTATE = {
	NORMAL: 1,
	// 值班室: 2,
	// 配电室1: 3,
	// 配电室2: 4,
	// 地下管道: 5,
}


const SceneScale = 0.0002;

export default {

	name: "threed",
	components: {
		infoboxSB,
	},
	props:{
		alarms:Object
	},
	data() {
		return {
			dialogVisible: false,
			clock: new THREE.Clock(),
			info_show: false,
			hover_show: false,
			hover_name: "",
			// choose_data: {},
			choose_id: '',
			info_type: "",
			ctb: "c_bt1",
			ctb2: 'c_bt2',
			stateNow: 1,
			info_show2: '',
			in_show1: "",
			percentage: 0,
			warnNameArray:[],//故障闪烁
			faultNameArray:[],//告警闪烁
		};
	},
	beforeDestroy() {
		this.close_page();
	},

	methods: {
		// 获取视角
		outPosition() {
			var { x, y, z } = this.controls.target
			x = parseFloat(x.toFixed(3))
			y = parseFloat(y.toFixed(3))
			z = parseFloat(z.toFixed(3))
			let a = [x, y, z]
			var { x, y, z } = this.camera.position
			x = parseFloat(x.toFixed(3))
			y = parseFloat(y.toFixed(3))
			z = parseFloat(z.toFixed(3))
			let v3 = `new THREE.Vector3(${a[0]},${a[1]},${a[2]}), new THREE.Vector3(${x},${y},${z}), `
			console.log([...a, x, y, z], ` ${v3}`)
		},
		perspectiveOne() {
			Commen.go_cameraV(
				new THREE.Vector3(3.583, 3.294, -6.775), new THREE.Vector3(-11.8, 40, 140.414),
				this.controls,
				this.camera,
				1,
				0
			)
		},

		perspectiveTwo() {
			Commen.go_cameraV(
				new THREE.Vector3(3.791, 3.912, -0.035), new THREE.Vector3(-138.281, 40, 10.052),
				this.controls,
				this.camera,
				1,
				0
			)
		},
		perspectiveThree() {
			Commen.go_cameraV(
				new THREE.Vector3(1.691, 6.714, 0.432), new THREE.Vector3(13.487, 40, -135.518),
				this.controls,
				this.camera,
				1,
				0
			)
		},
		perspectiveFour() {
			Commen.go_cameraV(
				new THREE.Vector3(1.59, 7.031, -0.305), new THREE.Vector3(133.932, 40, -10.48),
				this.controls,
				this.camera,
				1,
				0
			)
		},



		backgroundNight() {
			this.theldrCubeMap = this.ldrCubeMap1;
			for (let pl of this.spots) {
				pl.intensity = 5;
			}
		},

		backgroundDay() {
			this.theldrCubeMap = this.ldrCubeMap0;
			for (let pl of this.spots) {
				pl.intensity = 0;
			}
		},

		transparentAll() {
			this.transparency_group(this.object, 0.3);
		},

		opacityAll() {
			this.opacity_group(this.object);
		},

		buildingClick(content) {
			this.$message(`YOU CLICK ${content}`);
		},

		viewButtonClick(index) {
			let positions = [
				[new THREE.Vector3(2.611, -4.992, -0.901), new THREE.Vector3(25.011, 37.007, 45.506)],
				[new THREE.Vector3(1.325, -2.609, 4.503), new THREE.Vector3(-48.212, 19.253, 4.275)],
				[new THREE.Vector3(6.22, -5.234, -1.69), new THREE.Vector3(7.722, 25.569, 53.423)],
				[new THREE.Vector3(6.967, -7.551, 0.261), new THREE.Vector3(58.517, 36.659, 17.14)],
				[new THREE.Vector3(4.186, -6.968, 2.708), new THREE.Vector3(4.293, 82.789, -8.343)]
			];

			let [t, c] = positions[index];
			Commen.go_cameraV(t, c, this.controls, this.camera, 1, 0);
		},

		onload: function () {
			this.layers_0.set(0);
			this.layers_1.set(1);
			this.layers_hide.set(2);
			this.bloomLayer.set(1);
			this.init();

		},

		init: function () {

			this.initScene();


			this.scene.add(this.group_0);

			this.initBackground0();
			this.initBackground1();
			this.initBackground().then(this.initobj)
				.then((modelInfo) => {

					this.handleModel(modelInfo);
					this.updateProgress(1);

					this.initHint();
					this.initEvent();
					this.modelBloomEffect();

					this.animate();
					this.updateSceneState(1);
					// this.flowLightEffect();



				})
			this.addfloor();
			this.addeffect();
			this.initbloom();

		},

		initScene: function () {

			console.log(this);

			this.scene = new THREE.Scene();

			this.container = document.getElementById('container');

			this.camera = new THREE.PerspectiveCamera(45, this.container.clientWidth / this.container.clientHeight, 1, 10000);
			this.camera.position.set(0, 200, -10);
			this.currentLayer.disableAll();
			this.currentLayer.enable(0);
			this.currentLayer.enable(1);
			this.camera.layers = this.currentLayer;

			this.raycaster = new THREE.Raycaster();

			this.renderer = new THREE.WebGLRenderer({
				antialias: true,
				alpha: true
			});
			this.renderer.setClearAlpha(0);
			this.renderer.shadowMap.enabled = true;
			this.renderer.shadowMap.type = THREE.PCFShadowMap;
			this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
			this.renderer.setPixelRatio(window.devicePixelRatio);
			this.container.appendChild(this.renderer.domElement);
			this.renderer.setClearColor(0x000000, 1);
			this.renderer.toneMapping = THREE.NoToneMapping;//LinearToneMapping//NoToneMapping//ReinhardToneMapping


			this.controls = new OrbitControls(this.camera, this.renderer.domElement);
			this.controls.target.set(0, 0, 0);
			this.controls.autoRotateSpeed = 0.2;
			this.controls.enableDamping = true;
			this.controls.dampingFactor = 0.25;
			this.controls.maxPolarAngle = Math.PI / 2 * 0.9;
			//鼠标
			this.controls.mouseButtons = {
				LEFT: THREE.MOUSE.RIGHT,
				MIDDLE: THREE.MOUSE.LEFT,
				RIGHT: THREE.MOUSE.LEFT
			}

			//设置相机距离原点的最远距离 
			this.controls.update();
			this.renderer.domElement.removeAttribute("tabindex");


			var alight = new THREE.AmbientLight(0xFFFFFF, 1.0);

			this.scene.add(alight);
			this.dirLight = new THREE.DirectionalLight(0xffffff, 1);
			this.dirLight.castShadow = true;
			this.dirLight.position.set(-1, 2, 1);
			this.dirLight.target.position.copy(this.scene.position);
			this.dirLight.shadow.mapSize.width = 1024 * 2;  // default
			this.dirLight.shadow.mapSize.height = 1024 * 2; // default
			let l = 80;
			this.dirLight.shadow.camera.near = 0 - l;
			this.dirLight.shadow.camera.far = l;
			this.dirLight.shadow.camera.left = 0 - l;
			this.dirLight.shadow.camera.right = l;
			this.dirLight.shadow.camera.top = l;
			this.dirLight.shadow.camera.bottom = 0 - l;
			this.dirLight.shadow.radius = 3;
			this.scene.add(this.dirLight);

			let dl = new THREE.DirectionalLight(0xffffff, 0.1);
			dl.position.set(-1, 0, 1);
			dl.target.position.copy(this.scene.position);
			this.scene.add(dl);

			let dl1 = new THREE.DirectionalLight(0xffffff, 0.1);
			dl1.position.set(1, 0, -1);
			dl1.target.position.copy(this.scene.position);
			this.scene.add(dl1);

			// RectAreaLightUniformsLib.init();
			// const rectLight = new THREE.RectAreaLight(0xffffff, 1.0, 50, 50);
			// rectLight.position.set(3, 5, 3);
			// rectLight.lookAt(8.157, 0.018, 3.852);
			// this.scene.add(rectLight)

		},

		initobj: function (n = 'model') {

			return new Promise((res, rej) => {
				let onProgress = (xhr) => {
					if (xhr.lengthComputable) {
						let a = xhr.loaded / xhr.total;
						//console.log(a);
						a = a * 100;
						a = a.toFixed(0) * 1;

						this.percentage = a;
					}
				};
				let onError = function (xhr) {
					rej(xhr);
				};

				let loader = new FBXLoader();
				let path = `https://yliiotcloud.obs.cn-east-3.myhuaweicloud.com/model%281%29.fbx`;
				loader.load(path, (object) => {

					let objs = {}
					object.traverse((child) => {
						if (objs[child.type]) {
							objs[child.type][child.name] = child;
						} else {
							objs[child.type] = {};
							objs[child.type][child.name] = child;
						}
					})

					let mats = {};
					let identify = 'name'
					for (let im in objs.Mesh) {
						let mesh = objs.Mesh[im];
						let mat = mesh.material;
						if (Array.isArray(mat)) {
							for (let ma of mat) {
								if (!mats[ma[identify]]) {
									mats[ma[identify]] = ma
								}
							}
						} else {
							if (!mats[mat[identify]]) {
								mats[mat[identify]] = mat
							}
						}
					}

					res({ object: object, objs: objs, mats: mats });
				},
					onProgress,
					onError
				);
			})
		},

		handleModel: function (modelInfo) {
			let { object, objs, mats } = modelInfo;
			let s = new THREE.Vector3(1, 1, 1).multiplyScalar(SceneScale);
			object.scale.copy(s);
			object.updateMatrixWorld();
			this.scene.add(object);
			this.object = object

			this.equipmentDataMap = {
                // "ZhiChengDiZuo1": '支撑底座',
                // "YouGuanDao": '油管道',
                "SanJiYeLun": '三级叶轮',
                "SanJiKongLengQi": '三级空冷器',
                "FangKongFa": '放空阀',
                "PaiQiKou": '排气口',
                "YouBeng": '油泵',
                "QuYouWuQi": '去油雾器',
                "ZhuDianJiJieXianHe": '主电机接线盒',
                "ZhuDianJi": '主电机',
                "YouXiang": '油箱',
                "YouLengQi": '油冷器',
                "YouGuoLvQi": '油过滤器',
                "YiJiLengQieQi": '一级空冷器',
                "YiJiChiLun": '一级叶轮',
                "KongZhiGui": '控制柜',
                "JinQiKou": '进气口',
                "ErJiYeLun": '二级叶轮',
                "ErJiLengQieQi": '二级空冷器',
                "DaoYeFa": '导叶阀',
                "ChiLunXiang2": '齿轮箱'
            }


			this.equipmentModels = [];
			for (let n in this.equipmentDataMap) {
				let mesh = objs.Mesh[n];
				if (!mesh) {
					console.log(`equipmentDataMap : ${n} not found!`);
					continue;
				}
				this.equipmentModels.push(mesh);
			}

			for (const i in mats) {
				let mat = mats[i]
				mat.vertexColors = false;
				let item = mats[i]
				item.envMap = this.ldrCubeMap;
				item.combine = THREE.AddOperation;
				item.reflectivity = 0.7
				item.shininess = 150;
				item.needsUpdate = true;
				item.side = THREE.DoubleSide
			}

			// YouLengQi1
			// let m_tem = ['YouLengQi1', 'touming', 'lan'];
			// m_tem.forEach(i => {
			// 	let item = mats[i]
			// 	item.envMap = this.ldrCubeMap;
			// 	item.combine = THREE.AddOperation;
			// 	item.reflectivity = 0.5
			// 	item.shininess = 150;
			// 	item.needsUpdate = true;
			// 	item.side = THREE.DoubleSide
			// });

		},

		updateSceneState(stateNew) {

			let that = this;

			return new Promise(res => {

				beforeStateChange.bind(this)()
					.then(() => {
						this.stateNow = stateNew
						afterStateChange.bind(this)();
					}).then(() => {
						res()
					});
			})

			function beforeStateChange() {

				return new Promise(res => {

					switch (this.stateNow) {

						case SCENESTATE.NORMAL: {
							// this.outlinePass1.selectedObjects = [];
							// this.outlinePass2.selectedObjects = [];
							break;
						}
						default: {
							break;
						}
					}
					res();
				});
			}

			function afterStateChange() {

				return new Promise(res => {

					switch (stateNew) {

						case SCENESTATE.NORMAL: {
							let os = visibleOnStateFlag.bind(this)(stateNew);
							Commen.go_cameraV(
								new THREE.Vector3(-8.021, 4.64, 0.248),
								new THREE.Vector3(66.731, 73.847, 111.766),
								this.controls, this.camera,
								1, 0.5);

							break;
						}

						default: {
							// os = os.filter(x => x.isMesh);
							// this.focusObject3d(os, { offset: new THREE.Vector3(3, 2, 3) });
							break;
						}
					}
					res();
				});
			}

			function visibleOnStateFlag(state, focus = false, trans = false) {

				let opacities = [];

				this.scene.traverse((child) => {

					if (!child.sceneStateFlag) return;
					if (!child.isMesh && !child.isGroup && !child.isSprite && !child.isCSS2DObject) return;

					let isOpacity = child.sceneStateFlag.indexOf(state) != -1;
					if (isOpacity) {

						if (trans) {
							if (child.isMesh || child.isGroup) {
								child.visible = true;
							} else {
								child.visible = false;
							}
							this.opacity_group(child);
						} else {
							child.visible = isOpacity;
						}
						opacities.push(child);
					} else {

						if (trans) {
							if (child.isMesh || child.isGroup) {
								child.visible = true;
							} else {
								child.visible = false;
							}
							this.transparency_group(child);
						} else {
							child.visible = isOpacity;
						}
					}
				})

				return opacities;
			}

			return;

		},

		focusObject3d(objs, option) {

			let defaultOption = {
				offset: new THREE.Vector3(-1, 0.1, 0),
				scale: 0.7,
				duration: 1,
			}

			let option1 = option || {};

			let opt = {};
			Object.assign(opt, defaultOption, option1)

			let { offset, scale, duration } = opt;


			if (!objs.isMesh && !objs.isGroup && !Array.isArray(objs)) {
				console.log(`focusObject3d error : {objs}:${objs} is not mesh, group or array!`);
				return new Promise((r) => { r() });
			}

			let box = new THREE.Box3();
			if (Array.isArray(objs)) {
				for (let o of objs) {
					o.updateMatrixWorld();
					box.expandByObject(o);
				}
			} else {
				objs.updateMatrixWorld();
				box.setFromObject(objs);
			}
			let diagonal = box.min.distanceTo(box.max);
			let target = new THREE.Vector3();
			box.getCenter(target);
			offset.normalize();
			let cameraZoom = diagonal / 2 / scale;
			offset.multiplyScalar(cameraZoom);
			let position = target.clone().add(offset);
			return Commen.go_cameraV(target, position, this.controls, this.camera, duration, 0);
		},

		reset_camera: function () {
			return new Promise((res, rej) => {
				Commen.go_camera(2.68, -6.895, -4.557, 35.825, 23.066, 37.664, this.controls, this.camera, 1, 0);
				res();

			})
		},

		initHint() {

			// "ZhiChengDiZuo1": '支撑底座',
			// "YouGuanDao": '油管道',
			// "SanJiYeLun": '三级叶轮',
			// "SanJiKongLengQi": '三级空冷器',
			// "FangKongFa": '放空阀',
			// "PaiQiKou": '排气口',
			// "YouBeng": '油泵',
			// "QuYouWuQi": '去油雾器',
			// "ZhuDianJiJieXianHe": '主电机接线盒',
			// "ZhuDianJi": '主电机',
			// "YouXiang": '油箱',
			// "YouLengQi": '油冷器',
			// "YouGuoLvQi": '油过滤器',
			// "YiJiLengQieQi": '一级空冷器',
			// "YiJiChiLun": '一级叶轮',
			// "KongZhiGui": '控制柜',
			// "JinQiKou": '进气口',
			// "ErJiYeLun": '二级叶轮',
			// "ErJiLengQieQi": '二级空冷器',
			// "DaoYeFa": '导叶阀',
			// "ChiLunXiang2": '齿轮箱'
			
			//需要生成报警的设备为名称
			// Object.values(this.alarms).forEach(el=>{
			// 	console.log(el)
			// })
			let warnModelName = [];
			let faultModeltName = [];
			for(let warnName of this.warnNameArray){
				for (let n in this.equipmentDataMap) {
					if (this.equipmentDataMap[n] == warnName) {
						warnModelName.push(n);
						break;
					}
				}
			}
			for(let faultName of this.faultNameArray){
				for (let n in this.equipmentDataMap) {
					if (this.equipmentDataMap[n] == faultName) {
						faultModeltName.push(n);
						break;
					}
				}
			}

			
			//如果没有找到对应的模型名称，则返回
			if (!warnModelName) return;
			if (!faultModeltName) return;
			let warnModels = [];
			let faultModels = [];
			for(let warnModel of warnModelName){
				warnModels.push(this.scene.getObjectByName(warnModel))
			}
			for(let faultModel of faultModeltName){
				faultModels.push(this.scene.getObjectByName(faultModel))
			}
			if (!warnModels) return;
			if (!faultModels) return;

			//获取模型的包围盒，并确定报警图片的位置
			let box = new THREE.Box3();
			let center = new THREE.Vector3();
			for(let wm of warnModels){
				box.setFromObject(wm);
			}
			for(let fm of faultModels){
				box.setFromObject(fm);
			}
			box.getCenter(center);
			let pos = new THREE.Vector3(center.x, box.max.y + 10, center.z);

			//生成报警图片			 
			let warn = this.createImageHint(pos);
			//报警点的显示名称
			warn.name = '控制器：数据异常！';
			warn.traverse(x => {
				x.name = warn.name;
			})
			//把报警图片添加到场景中
			this.scene.add(warn);
			//把报警图片添加到渲染队列中
			this.warn = warn;
			this.outlinePass3.selectedObjects = [...warnModels];
			this.outlinePass2.selectedObjects = [...faultModels];

		},

		areaLabel(pos1, content, size = 0.7, flag = false) {

			let { x, y, z } = pos1
			let loader = new THREE.TextureLoader()
			loader.needsUpdate = true;
			let hint1, sprite_word, spriteMap;

			let pos = new THREE.Vector3(x, y, z);

			spriteMap = loader.load("textures/hint/di.png");
			let mat = new THREE.SpriteMaterial({
				map: spriteMap,
				// depthWrite: false,
				// transparent: true,
				// opacity: 0.7,
			})
			hint1 = new THREE.Sprite(mat);

			let num = Commen.strLen(content);


			let fontsize = 15;
			let textDefinition = 10;

			let canvasHeight = fontsize * 1;
			let canvasWidth = canvasHeight * Commen.strLen(content);
			let canvasRadio = canvasWidth / canvasHeight;


			let wordHeight = fontsize / canvasHeight * size;
			let wordWidth = num * wordHeight;
			let backHeight = wordHeight * 2;
			let backWidth = wordWidth * 1.1;

			let centerY = (1 - 2 / canvasRadio) / 2 + 0.01;

			sprite_word = Commen.makeTextSprite(content, { fontsize: fontsize * textDefinition });

			hint1.center = new THREE.Vector2(0.5, 0.5);
			sprite_word.center = new THREE.Vector2(0.5, centerY);
			// sprite_word.center = new THREE.Vector2(0.5, centerY + 0.05);

			hint1.scale.copy(new THREE.Vector3(backWidth, backHeight, 0.05))
			// hint1.scale.copy(new THREE.Vector3(size / 15, size / 15, 0.05))
			sprite_word.scale.copy(new THREE.Vector3(wordWidth, wordHeight, 0.05))

			hint1.position.copy(pos)
			sprite_word.position.copy(pos)

			let group = new THREE.Group();
			group.add(hint1, sprite_word);
			hint1.sceneStateFlag = flag;
			return group;
		},

		createImageHint(pos1, imgPath, size = 10,) {
			console.log(pos1);
			let { x, y, z } = pos1
			let loader = new THREE.TextureLoader()
			loader.needsUpdate = true;
			let hint1, spriteMap;

			let pos = new THREE.Vector3(x, y, z);

			spriteMap = loader.load(imgPath);
			let mat = new THREE.SpriteMaterial({
				map: spriteMap,
				// depthWrite: false,
				// transparent: true,
				// opacity: 0.7,
			})
			hint1 = new THREE.Sprite(mat);
			hint1.center = new THREE.Vector2(0.5, 0.5);
			hint1.scale.copy(new THREE.Vector3(size, size, 0.05))
			hint1.position.copy(pos)

			let group = new THREE.Group();
			group.add(hint1);

			console.log(group);

			return group;
		},

		initEvent: function () {
			this.eventHandler = new EventHandler(this);

			//需要把报警图片添加到渲染队列中
			this.eventHandler.enableMouseMove([...this.equipmentModels, this.warn]);
			this.eventHandler.addEventListener('move', (e) => {
				let intersects = e.intersects;
				if (intersects.length == 0) {
					// this.info_show=true
					this.hover_show = false;
					this.outlinePass.selectedObjects = [];
					return
				}

				this.hover_show = true;
				this.hover_name = this.equipmentDataMap[intersects[0].object.name] || intersects[0].object.name;
				this.hover_sp = intersects[0].point;
				this.outlinePass.selectedObjects = [intersects[0].object];

			})

			this.eventHandler.addEventListener('click', (e) => {

				let intersects = e.intersects;
				let equipmentName = this.equipmentDataMap[intersects[0].object.name];
				if (intersects.length == 0 || !equipmentName) {
					this.info_show = false;
					return;
				}
				this.info_show = true;
				this.choose_id = equipmentName;
				this.choose_sp = intersects[0].point;
				setTimeout(()=>{
					this.$refs.infobox.componentDataOf3D(this.choose_id)
				},100)

				// let intersects2 = e.intersects
				// let obj = intersects2[0].object
				// if (obj.name == 'lixinji') {
				// 	this.choose_sp = intersects2[0].point
				// 	this.info_show = true
				// } else {
				// 	this.info_show = false
				// }




				// intersects = e.intersects;
				// intersects = intersects.filter(x => {
				// 	if (x.object.isFloor) return true;
				// 	return false;
				// })
				// if (intersects.length > 0) {
				// 	// this.info_show=true
				// 	let name = intersects[0].object.name;
				// 	let key = FLOORKEY[name]
				// 	if (name) {
				// 		this.$router.push({ path: '/floor', query: { key } });
				// 		return;
				// 	}
				// }

				// intersects = e.intersects;
				// intersects = intersects.filter(x => {
				// 	if (x.object.isSelectable) return true;
				// 	return false;
				// })
				// if (intersects.length > 0) {
				// 	if (intersects[0].object.isSelectable) {
				// 		let name = intersects[0].object.parent.name;
				// 		let names = name.split('_');
				// 		if (names.length > 1) {
				// 			this.buildingClick(names[1]);
				// 		}
				// 	}
				// 	return;
				// }


			})
		},

		initbloom: function () {

			this.composer = new EffectComposer(this.renderer);
			let renderScene = new RenderPass(this.scene, this.camera);
			this.composer.addPass(renderScene);

			this.bloomPass = new UnrealBloomPass(new THREE.Vector2(this.container.clientWidth, this.container.clientHeight), 1.5, 0.4, 0.85);
			this.bloomPass.threshold = this.params.bloomThreshold;
			this.bloomPass.strength = this.params.bloomStrength;
			this.bloomPass.radius = this.params.bloomRadius;
			this.composer.renderToScreen = false;
			this.composer.addPass(this.bloomPass);

			this.outlinePass = new OutlinePass(new THREE.Vector2(this.container.clientWidth, this.container.clientHeight), this.scene, this.camera);
			this.composer.addPass(this.outlinePass);

			this.outlinePass1 = new OutlinePass(new THREE.Vector2(this.container.clientWidth, this.container.clientHeight), this.scene, this.camera);
			// this.composer.addPass(this.outlinePass1);

			this.outlinePass2 = new OutlinePass(new THREE.Vector2(this.container.clientWidth, this.container.clientHeight), this.scene, this.camera);
			this.composer.addPass(this.outlinePass2);

			this.outlinePass3 = new OutlinePass(new THREE.Vector2(this.container.clientWidth, this.container.clientHeight), this.scene, this.camera);
			this.composer.addPass(this.outlinePass3);
			this.outlinePass4 = new OutlinePass(new THREE.Vector2(this.container.clientWidth, this.container.clientHeight), this.scene, this.camera);
			//this.composer.addPass(this.outlinePass3);

			this.outlinePass.edgeStrength = 5;
			this.outlinePass.edgeGlow = 1.5;
			this.outlinePass.edgeThickness = 1.5;
			this.outlinePass.pulsePeriod = 2;
			this.outlinePass.visibleEdgeColor = new THREE.Color(0x45b870);
			this.outlinePass.hiddenEdgeColor = new THREE.Color(0x45b870);
			this.outlinePass.id = 1;

			this.outlinePass1.edgeStrength = 3;
			this.outlinePass1.edgeGlow = 1;
			this.outlinePass1.edgeThickness = 1;
			this.outlinePass1.pulsePeriod = 2;
			this.outlinePass1.visibleEdgeColor = new THREE.Color(0x00ff00);
			this.outlinePass1.hiddenEdgeColor = new THREE.Color(0x00ff00);
			this.outlinePass1.id = 2;

			this.outlinePass2.edgeStrength = 6;
			this.outlinePass2.edgeGlow = 2;
			this.outlinePass2.edgeThickness = 2;
			this.outlinePass2.pulsePeriod = 2;
			this.outlinePass2.visibleEdgeColor = new THREE.Color(0xff0000);
			this.outlinePass2.hiddenEdgeColor = new THREE.Color(0xff0000);
			this.outlinePass2.id = 6;

			this.outlinePass3.edgeStrength = 6;
			this.outlinePass3.edgeGlow = 2;
			this.outlinePass3.edgeThickness = 2;
			this.outlinePass3.pulsePeriod = 2;
			this.outlinePass3.visibleEdgeColor = new THREE.Color(0xfff600);
			this.outlinePass3.hiddenEdgeColor = new THREE.Color(0xfff600);
			this.outlinePass3.id = 4;

			this.outlinePass4.edgeStrength = 5;
			this.outlinePass4.edgeGlow = 1.5;
			this.outlinePass4.edgeThickness = 1.5;
			this.outlinePass4.pulsePeriod = 2;
			this.outlinePass4.visibleEdgeColor = new THREE.Color(0x18ce99);
			this.outlinePass4.hiddenEdgeColor = new THREE.Color(0x18ce99);
			this.outlinePass4.id = 5;


			this.effectFXAA = new ShaderPass(FXAAShader);
			this.effectFXAA.uniforms['resolution'].value.set(1 / this.container.clientWidth, 1 / this.container.clientHeight);
			this.effectFXAA.renderToScreen = true;
			this.composer.addPass(this.effectFXAA);

			let vertexShader = `
				varying vec2 vUv;
				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}
			`;

			let fragmentshader = `
				uniform sampler2D baseTexture;
				uniform sampler2D bloomTexture;
				varying vec2 vUv;
				void main() {
					gl_FragColor = ( texture2D( baseTexture, vUv ) + vec4( 1.0 ) * texture2D( bloomTexture, vUv ) );
				}
			`

			let finalPass = new ShaderPass(
				new THREE.ShaderMaterial({
					uniforms: {
						baseTexture: { value: null },
						bloomTexture: { value: this.composer.renderTarget2.texture }
					},
					vertexShader: vertexShader,
					fragmentShader: fragmentshader,
					defines: {}
				}), "baseTexture"
			);
			finalPass.needsSwap = true;

			this.finalComposer = new EffectComposer(this.renderer);
			this.finalComposer.addPass(renderScene);
			this.finalComposer.addPass(finalPass);

		},

		darkenNonBloomed(obj) {
			if ((obj.isMesh || obj.isLineSegments) && this.bloomLayer.test(obj.layers) === false) {
				this.materials[obj.uuid] = obj.material;
				obj.material = this.darkMaterial;
			} else if (obj.isSprite && this.bloomLayer.test(obj.layers) === false) {
				this.materials[obj.uuid] = obj.material;
				obj.material = this.darkMaterial_t;
			}
		},

		restoreMaterial(obj) {
			if (this.materials[obj.uuid]) {
				obj.material = this.materials[obj.uuid];
				delete this.materials[obj.uuid];
			}
		},

		updateProgress: function (per) {
			this.allPer += per;
			let t = (this.allPer * 100).toFixed(2) + '%';
			if ('100.00%' == t) {

				setTimeout(() => {
					// this.active_sel = [this.scene];
					// this.reset_camera();
					$(".loading").fadeOut(1000);
				}, 1000);
			}
		},

		animate: function () {
			this.requestId = requestAnimationFrame(this.animate);
			this.controls.update();
			this.render();
			this.scene.traverse(this.darkenNonBloomed);
			this.scene.background = new THREE.Color(0x000000);
			this.composer.render();

			this.scene.traverse(this.restoreMaterial);
			this.scene.background = this.theldrCubeMap
			this.finalComposer.render();

		},

		render: function () {
			let delta = this.clock.getDelta();
			for (let j = 0; j < this.gif.length; j++) {
				if (this.gif[j]) this.gif[j].update(200 * delta);
			}
			if (this.info_show) {
				this.updateScreenPosition_info();
			}
			if (this.hover_show) {
				this.updateScreenPosition_hover();
			}

			if (this.effectmats) {
				for (let i = 0; i < this.effectmats.length; i++) {
					this.effectmats[i].map.offset.x -= 0.002;
				}
			}

			if (this.model_floor) {
				this.model_floor[0].rotation.z -= 0.002;
				this.model_floor[1].rotation.z -= 0.005;
				this.model_floor[2].rotation.z += 0.006;
				//this.model_floor[3].rotation.z -=0.005;
			}

			if (this.circleAni) {
				this.circleAni.render();
			}

			this.renderer.render(this.scene, this.camera);

		},

		updateScreenPosition_info() {			

			let vector = this.choose_sp.clone();
			vector.project(this.camera);
			const width = this.container.clientWidth;
			const height = this.container.clientHeight;
			const pixelX = ((vector.x + 1) * width) / 2;
			const pixelY = ((1 - vector.y) * height) / 2;
			$(".info").css("top", pixelY + 10 + "px");
			$(".info").css("left", pixelX + 10 + "px");			
		},

		updateScreenPosition_hover() {
			//let vector=this.choose_sp.position.clone();
			let vector = this.hover_sp.clone();
			vector.project(this.camera);
			const width = this.container.clientWidth;
			const height = this.container.clientHeight;
			const pixelX = ((vector.x + 1) * width) / 2;
			const pixelY = ((1 - vector.y) * height) / 2;
			let t = $(".hover_name").height();
			$(".hover_name").css("top", pixelY + - t * 2 - 10 + "px");
			$(".hover_name").css("left", pixelX + 10 + "px");
			// $(".hover_name").css("top", vector.y - t * 2 - 10 + "px");
			// $(".hover_name").css("left", vector.x + 10 + "px");
		},

		initBackground0: function () {

			THREE.DefaultLoadingManager.onLoad = function () {
				//pmremGenerator.dispose();
			};
			//let ldrUrls = [ 'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png' ];
			let ldrUrls = ['px.jpg', 'nx.jpg', 'py.jpg', 'ny.jpg', 'pz.jpg', 'nz.jpg'];
			this.ldrCubeMap0 = new THREE.CubeTextureLoader()
				.setPath('textures/cube/cube_sky/')//Park3Med
				.load(ldrUrls, () => {
					//this.ldrCubeMap0.encoding = THREE.GammaEncoding;
					//this.ldrCubeMap0.encoding = THREE.sRGBEncoding;
					// this.theldrCubeMap = this.ldrCubeMap0;
				});
		},

		initBackground1: function () {

			THREE.DefaultLoadingManager.onLoad = function () {
				//pmremGenerator.dispose();
			};
			//let ldrUrls = [ 'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png' ];
			let ldrUrls = ['px.jpg', 'nx.jpg', 'py.jpg', 'ny.jpg', 'pz.jpg', 'nz.jpg'];
			this.ldrCubeMap1 = new THREE.CubeTextureLoader()
				.setPath('textures/cube/cube_night/')//Park3Med
				.load(ldrUrls, () => {
					//this.ldrCubeMap0.encoding = THREE.GammaEncoding;
					//this.ldrCubeMap0.encoding = THREE.sRGBEncoding;
					// this.scene.background = this.ldrCubeMap0;
					this.theldrCubeMap = this.ldrCubeMap1;

				});
		},

		initBackground: function () {
			return new Promise((res, rej) => {
				THREE.DefaultLoadingManager.onLoad = function () {
					//pmremGenerator.dispose();
				};
				//let ldrUrls = [ 'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png' ];
				let ldrUrls = ['px.jpg', 'nx.jpg', 'py.jpg', 'ny.jpg', 'pz.jpg', 'nz.jpg'];
				this.ldrCubeMap = new THREE.CubeTextureLoader()
					.setPath('textures/cube/Park3Med/')//Park3Med
					.load(ldrUrls, () => {
						//this.ldrCubeMap.encoding = THREE.GammaEncoding;
						this.ldrCubeMap.encoding = THREE.sRGBEncoding;
						//this.ldrCubeRenderTarget = pmremGenerator.fromCubemap( this.ldrCubeMap );
						// this.scene.background = this.ldrCubeMap;
						res();
					});
			})

		},

		addfloor: function () {

			let planeScale = 2;

			let defaultHeight = 0;
			let geometry_Mirror = new THREE.PlaneBufferGeometry(500 * planeScale, 500 * planeScale);
			var groundMirror = new Reflector(geometry_Mirror, {
				clipBias: 0.003,
				textureWidth: window.innerWidth * window.devicePixelRatio,
				textureHeight: window.innerHeight * window.devicePixelRatio,
			});
			groundMirror.position.set(0, defaultHeight - 0.3, 0);
			groundMirror.rotateX(- Math.PI / 2);
			groundMirror.name = "Mirror";
			// this.group_0.add(groundMirror);
			let planeGeometry = new THREE.PlaneGeometry(400 * planeScale, 400 * planeScale, 1, 1);
			let texture = new THREE.TextureLoader().load('textures/yuan.png');
			texture.wrapS = THREE.RepeatWrapping;
			texture.wrapT = THREE.RepeatWrapping;
			texture.repeat.set(1, 1);
			let meshMaterial = new THREE.MeshBasicMaterial({
				transparent: true,
				opacity: 0.5,
				map: texture,
				depthWrite: false,
			});
			let plane = new THREE.Mesh(planeGeometry, meshMaterial);
			plane.position.set(0, defaultHeight - 2.2, 0);
			plane.rotateX(-Math.PI / 2);
			plane.name = "floor";
			this.model_floor.push(plane);
			this.group_0.add(plane);

			planeGeometry = new THREE.PlaneGeometry(400 * planeScale, 400 * planeScale, 1, 1);
			texture = new THREE.TextureLoader().load('textures/yuan1.png');
			texture.wrapS = THREE.RepeatWrapping;
			texture.wrapT = THREE.RepeatWrapping;
			texture.repeat.set(1, 1);
			meshMaterial = new THREE.MeshBasicMaterial({
				transparent: true,
				opacity: 0.2,
				map: texture,
				depthWrite: false,
			});
			plane = new THREE.Mesh(planeGeometry, meshMaterial);
			plane.position.set(0, defaultHeight - 2.4, 0);
			plane.rotateX(-Math.PI / 2);
			plane.name = "floor";
			this.model_floor.push(plane);
			this.group_0.add(plane);

			planeGeometry = new THREE.PlaneGeometry(700 * planeScale, 700 * planeScale, 1, 1);
			texture = new THREE.TextureLoader().load('textures/yuan2.png');
			texture.wrapS = THREE.RepeatWrapping;
			texture.wrapT = THREE.RepeatWrapping;
			texture.repeat.set(1, 1);
			meshMaterial = new THREE.MeshBasicMaterial({
				transparent: true,
				opacity: 0.2,
				map: texture,
				depthWrite: false,
			});
			plane = new THREE.Mesh(planeGeometry, meshMaterial);
			plane.position.set(0, defaultHeight - 2.6, 0);
			plane.rotateX(-Math.PI / 2);
			plane.name = "floor";
			this.model_floor.push(plane);
			this.group_0.add(plane);

			planeGeometry = new THREE.PlaneGeometry(700 * planeScale, 700 * planeScale, 1, 1);
			texture = new THREE.TextureLoader().load('textures/yuan3.png');
			texture.wrapS = THREE.RepeatWrapping;
			texture.wrapT = THREE.RepeatWrapping;
			texture.repeat.set(1, 1);
			meshMaterial = new THREE.MeshBasicMaterial({
				transparent: true,
				opacity: 0.1,
				map: texture,
				depthWrite: false,
			});
			plane = new THREE.Mesh(planeGeometry, meshMaterial);
			plane.position.set(0, defaultHeight - 2.8, 0);
			plane.rotateX(-Math.PI / 2);
			plane.name = "floor";
			//this.model_floor.push(plane);
			//this.group_0.add(plane);

			//底面
			let repeat = 2000
			planeGeometry = new THREE.PlaneGeometry(repeat * 10, repeat * 10, 1, 1);
			texture = new THREE.TextureLoader().load('textures/pt.png');
			texture.wrapS = THREE.RepeatWrapping;
			texture.wrapT = THREE.RepeatWrapping;
			texture.repeat.set(repeat, repeat);
			meshMaterial = new THREE.MeshBasicMaterial({
				transparent: true,
				opacity: 0.2,
				map: texture,
				depthWrite: false,
			});
			plane = new THREE.Mesh(planeGeometry, meshMaterial);
			plane.position.set(0, defaultHeight - 3, 0);
			plane.rotateX(-Math.PI / 2);
			plane.name = "floor";
			this.group_0.add(plane);

		},

		addeffect: function () {

			let effectScale = 300

			let effectMaterial = new THREE.MeshBasicMaterial({
				transparent: true,
				depthWrite: false,
				side: THREE.DoubleSide,
				opacity: 0.2,
			})

			let geometry = new THREE.CylinderGeometry(0.00015 * effectScale, 0.00015 * effectScale, 0.30 * effectScale, 4, 1);
			let effectMesh;

			for (let i = 0; i < 10; i++) {
				let effectMap = new THREE.TextureLoader().load("textures/lightFlow_strip07.png");
				effectMap.wrapS = THREE.RepeatWrapping
				effectMap.wrapT = THREE.RepeatWrapping
				effectMap.rotation = Math.PI / 2;

				let mt = effectMaterial.clone();
				this.effectmats.push(mt);
				mt.map = effectMap;

				effectMesh = new THREE.Mesh(geometry, mt);
				let x = Math.round((Math.random() - 0.5) * effectScale);
				let z = Math.round((Math.random() - 0.5) * effectScale);
				effectMesh.position.set(x, 30, z);
				let e = Math.random();
				mt.map.offset.x = e;
				effectMesh.layers = this.layers_1;
				effectMesh.name = "flyline";
				this.group_0.add(effectMesh);
			}
		},


		//透明
		transparency_group(group, opacity = 0.1) {
			let that = this;
			group.traverse((child) => {
				if (child.isMesh || child.isSprite) {
					let m = child.material;
					if (Array.isArray(m)) {
						let mats = []
						for (let item of m) {
							mats.push(changeMaterial(item));
						}
						child.material = mats;
					} else {
						child.material = changeMaterial(m)
					}
				} else if (child.isLineSegments) {
					child.layers = this.layers_hide;
				}
			});

			function changeMaterial(mat) {
				if (mat.changed) {
					return mat;
				}
				if (!that.materialStore) that.materialStore = {};
				that.materialStore[mat.id] = mat;
				let mat1 = mat.clone();
				mat1.changed = true;
				mat1.depthWrite = false;
				mat1.transparent = true;
				mat1.opacity = opacity;
				mat1.oldId = mat.id;
				return mat1;
			}
		},

		//不透明
		opacity_group(group) {
			let that = this;
			group.traverse((child) => {
				if (child.isMesh || child.isSprite || child.isLineSegments) {
					let m = child.material;
					if (Array.isArray(m)) {
						let mats = []
						for (let item of m) {
							mats.push(resetMaterial(item));
						}
						child.material = mats;
					} else {
						child.material = resetMaterial(m)
					}
				}
			});

			function resetMaterial(mat) {
				let rs = mat;
				if (mat.oldId || mat.oldId == 0) {
					rs = that.materialStore[mat.oldId] || mat;
				}
				return rs;
			}
		},

		bloom_group: function (g) {
			return new Promise((res, rej) => {
				g.traverse((child) => {
					if (child.isMesh || child.isSprite || child.isLineSegments) {
						child.layers = this.layers_1;
						if ('hz' == child.material.name) {
							child.material.depthTest = false;
							child.material.depthWrite = false;
						}
					}
				})
				res(null);
			})
		},

		delete_group: function (group) {
			return new Promise((res, rej) => {
				if (group) {
					let arr = group.children.filter(x => x);
					for (let a of arr) {
						this.dispose(group, a);
					}
				}
				res(null);
			})
		},

		close_page: function () {
			window.removeEventListener('resize', this.onWindowResize, false);
			window.removeEventListener('mousemove', this.onMouseMove);
			this.renderer.domElement.removeEventListener('pointerdown', this.onMouseDown, false);
			this.renderer.domElement.removeEventListener('pointerup', this.onMouseUp, false);
			window.removeEventListener('dblclick', this.onDblClick);
			let arr = this.scene.children.filter(x => x)
			arr.forEach(a => {
				this.dispose(this.scene, a);
			})

			this.scene.remove();
			this.renderer.renderLists.dispose();
			this.renderer.dispose();
			this.renderer.forceContextLoss();
			this.renderer.content = null;
			this.renderer.domElement = null;
			this.renderer = null;
			window.cancelAnimationFrame(this.requestId);
			this.raycaster = null;
			this.camera = null;
			this.controls = null;
			this.composer = null;

			//
			this.scene = null;
			this.group_0 = null;
			this.group_1 = null;
			this.group_h = null;
			this.group_h2 = null;
			this.gif = null;
			this.point_texture = null;
		},

		dispose: function (parent, child) {
			if (child.children.length) {
				let arr = child.children.filter(x => x);
				arr.forEach(a => {
					this.dispose(child, a)
				})
			}
			if (child instanceof THREE.Mesh || child instanceof THREE.LineSegments) {
				if (child.material.map) if (child.material.map.dispose) child.material.map.dispose();
				if (child.geometry.dispose) child.geometry.dispose();
				if (child.material.dispose) child.material.dispose();

			} else if (child.material) {
				child.material.dispose();
			}
			child.remove();
			parent.remove(child);
		},

		flowLightEffect() {

			let that = this;

			let repeatTime = 2;
			let group = new THREE.Group();
			let path1 = [
				new THREE.Vector3(44.972, 0.2, 6.927),
				new THREE.Vector3(-41.326, 0.2, 47.048),
			]
			let path2 = [
				new THREE.Vector3(-35.797, 0.2, 47.100),
				new THREE.Vector3(45.063, 0.2, 9.485),
			]

			let path3 = [
				new THREE.Vector3(40.671, 0.3, 5.060),
				new THREE.Vector3(32.164, 0.3, -13.226),
				new THREE.Vector3(28.719, 0.3, -24.828),
				new THREE.Vector3(27.475, 0.3, -31.395),
				new THREE.Vector3(26.094, 0.3, -46.822),
				new THREE.Vector3(27.475, 0.3, -31.395),
				new THREE.Vector3(28.719, 0.3, -24.828),
				new THREE.Vector3(32.164, 0.3, -13.226),
			]

			let path4 = [
				new THREE.Vector3(23.736, 0.3, -46.921),
				new THREE.Vector3(25.053, 0.3, -32.700),
				new THREE.Vector3(26.363, 0.3, -25.163),
				new THREE.Vector3(28.716, 0.3, -16.573),
				new THREE.Vector3(30.596, 0.3, -11.367),
				new THREE.Vector3(38.769, 0.3, 5.989),
				new THREE.Vector3(30.596, 0.3, -11.367),
				new THREE.Vector3(28.716, 0.3, -16.573),
				new THREE.Vector3(26.363, 0.3, -25.163),
				new THREE.Vector3(25.053, 0.3, -32.700),
			]

			let path5 = [
				new THREE.Vector3(59.266, 0.2, 59.873),
				new THREE.Vector3(59.499, 0.2, -57.965),
				new THREE.Vector3(-58.535, 0.2, -58.140),
				new THREE.Vector3(-58.479, 0.2, 59.859),
			]

			let path6 = [
				new THREE.Vector3(-58.535, 0.2, -58.140),
				new THREE.Vector3(-58.479, 0.2, 59.859),
				new THREE.Vector3(59.266, 0.2, 59.873),
				new THREE.Vector3(59.499, 0.2, -57.965),
			]

			// let paths = [path1, path2, path3, path4, path5, path6];
			let paths = [path1, path2, path3, path4];

			for (let i in paths) {
				let path = paths[i];
				let curve = new THREE.CatmullRomCurve3(path, true);
				let index = i % 2;
				let flow = addline(curve, index);
				group.add(flow);

				Tween.gsap.to(flow.material.map.offset, {
					x: -1, duration: repeatTime, ease: 'none', repeat: -1,
					onUpdate: () => {
						flow.material.map.needsUpdate = true;
					}
				})
			}
			this.scene.add(group);

			return group;

			function addline(curve, state, g) {
				curve.curveType = 'catmullrom';
				curve.tension = 0.01;
				let color;

				if (state == 0) {
					color = 'textures/light0.png';
				} else {
					color = 'textures/light1.png';
				}

				let k = 0.01;//截面
				let tubeGeometry = new THREE.TubeGeometry(curve, 1000, 0.1, 8, false);
				let textureLoader = new THREE.TextureLoader();
				let texture = textureLoader.load(color);
				texture.repeat.set(1, 1);
				texture.wrapS = THREE.RepeatWrapping;
				texture.wrapT = THREE.RepeatWrapping;

				let tubeMaterial = new THREE.MeshPhongMaterial({
					map: texture,
					transparent: true,
					opacity: 0.5,
					depthWrite: false
				});

				let mesh = new THREE.Mesh(tubeGeometry, tubeMaterial);
				mesh.name = "flowlight";
				mesh.layers = that.layers_1;
				return mesh;
			}

		},

		modelBloomEffect(groups = this.bloomModels) {
			for (let g of groups) {
				this.bloom_group(g);
			}
		},
	},

	beforeMount() {

	},
	watch:{
		alarms:{
			handler(n, o) {
				this.faultNameArray = [];
				this.warnNameArray = [];
				if(Object.keys(this.alarms).length != 0){
					Object.keys(this.alarms).forEach(el=>{
						if(this.alarms[el] == 'yellow'){
							this.warnNameArray.push(el);
						}else if(this.alarms[el] == 'red'){
							this.faultNameArray.push(el);
						}
					})
				}
				this.initHint()
			},
			deep: true
		}
	},
	mounted() {
		this.bloomModels = [];
		this.container;
		this.scene;
		this.controls;
		this.camera;
		this.renderer;
		this.raycaster;
		this.clock = new THREE.Clock();
		this.mouse = new THREE.Vector2();
		this.selectedObjects = [];
		this.composer;
		this.effectFXAA;
		this.outlinePass;
		this.outlinePass1;
		this.outlinePass2;
		this.outlinePass3;
		// 
		this.outlinePass4;
		this.ldrCubeMap0;
		this.ldrCubeMap1;
		this.ldrCubeMap;
		this.theldrCubeMap;
		this.allPer = 0;
		this.tem_e = { x: 0, y: 0 };
		this.tem_right_e = { x: 0, y: 0 };
		this.dirLight;
		this.gif = [];
		this.effectmats = [];//飞线
		this.group_0 = new THREE.Group();
		this.group_1 = new THREE.Group();
		this.group_2 = new THREE.Group();
		this.group_h = new THREE.Group();
		this.group_h2 = new THREE.Group();
		this.group_pm = new THREE.Group();
		this.group_water = new THREE.Group();
		this.group_light = new THREE.Group();
		this.group_circle = new THREE.Group();
		this.currentLayer = new THREE.Layers();
		this.layers_0 = new THREE.Layers();
		this.layers_1 = new THREE.Layers();
		this.layers_hide = new THREE.Layers();

		this.lines = [];
		this.state = [];
		this.i_data = {};
		this.model_o = {};
		this.model_l = {};
		this.active_sel = [];
		this.model_yp = {};
		this.model_floor = [];
		// 1
		this.billboards = [];
		//单个模型对象
		this.model_ob = {};
		this.choose_sp = { x: 0, y: 0, z: 0 };//选中的sprite
		this.hover_sp = { x: 0, y: 0, z: 0 };//选中的sprite
		this.mt_water = [];
		this.material_circle = [];
		this.point_texture = {};

		this.materials = {};
		this.FPS = 60;
		this.renderT = 1 / this.FPS;
		this.timeS = 0;
		this.lines_ele = [];
		this.main_mt = [];

		//辉光
		this.params = {
			exposure: 1,
			bloomThreshold: 0.0,
			bloomStrength: 2.7,
			bloomRadius: 0,
		};
		this.bloomLayer = new THREE.Layers();
		this.darkMaterial = new THREE.MeshBasicMaterial({
			color: new THREE.Color(0x000000)
		});
		this.darkMaterial_t = new THREE.SpriteMaterial({
			color: new THREE.Color(0x000000)
		});

		this.bloomPass;
		this.finalComposer;
		this.requestId;
		this.onload();
	}
};
</script>
<style scoped>
#container {
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	overflow: hidden;
	z-index: 0;
}

.loading {
	position: absolute;
	z-index: 1;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	/* background-color: #000000 */
}

.loading_d {
	position: absolute;
	z-index: 1;
	top: calc(50% - 150px);
	text-align: center;
	color: white;
	width: 100%;
	font-size: 20px;
}

.loading_t {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	top: calc(50% - 15px);
	color: white;
	font-size: 20px;
}
.loading_progress {
	position: absolute;
	width: 20%;
	left: 50%;
	transform: translateX(-50%);
	top: calc(50% + 30px);
	color: white;
	font-size: 20px;
}

.home {
	position: absolute;
	top: 10px;
	right: 10px;
}
.rotate {
	position: absolute;
	top: 50px;
	right: 10px;
}
.el-button--primary {
	font-size: 16px;
}
.hover_name {
	position: absolute;
	*left: calc(50% - 80px);
	*margin: 10px auto;
	*top: 90px;
	color: white;
	font-size: 2vh;
	pointer-events: none;
	border: 2px solid #3695ff;
	-moz-border-radius: 15px;
	-webkit-border-radius: 15px;
	border-radius: 5px;
	padding: 1vh;
	*background: linear-gradient(rgba(6, 42, 108, 0.8), rgba(3, 19, 44, 0.8));
	background: linear-gradient(rgba(22, 31, 60, 0.6), rgba(13, 19, 36, 0.8));
}
.infobox {
	position: absolute;
	top: 300px;
	left: 800px;
	*min-width: 15vw;
	padding-bottom: 10px;
	*height: 150px;
	*background-color: rgba(22, 31, 60, 0.6);
	*background: linear-gradient(rgba(6, 42, 108, 0.8), rgba(3, 19, 44, 0.8));
	background: linear-gradient(rgba(22, 31, 60, 0.6), rgba(13, 19, 36, 0.8));
	border: 2px solid #3695ff;

	-moz-border-radius: 15px;
	-webkit-border-radius: 15px;
	border-radius: 15px;
	text-shadow: 1px 1px 1px #404040;
	pointer-events: none;
	z-index: 1;
}
.info {
	z-index: 2;
}
.choose {
	position: absolute;
	top: 10%;
	left: 26%;
	-moz-border-radius: 15px;
	-webkit-border-radius: 15px;
	border-radius: 15px;
	display: flex;
	z-index: 1;
}
</style>
 